import { render, staticRenderFns } from "./ViewDraftsTable.vue?vue&type=template&id=53ebb8dc"
import script from "./ViewDraftsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDraftsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports